import axios from "axios";
import { getGooglePlacesAutocompleteUrl, getGooglePlaceIdFromShareUrl, getGooglePlacesAutocompleteRegionUrl, getGooglePlaceDetailsUrl } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')


export default class GoogleRepository {
    async getPlacesAutocomplete(input) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getGooglePlacesAutocompleteUrl(input),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getPlaceDetails(placeId) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getGooglePlaceDetailsUrl(placeId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getPlacesAutocompleteRegion(input) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getGooglePlacesAutocompleteUrl(input),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getPlaceIdFromShareUrl(shareUrl) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getGooglePlaceIdFromShareUrl(),
            {
                originalUrl: shareUrl
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }
}
